import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToNotify = () => {
    const element = document.getElementById('notify-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-32 bg-brand-black text-white relative overflow-hidden text-center" data-id="element-107">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(13,148,136,0.15)_0,transparent_50%)]" data-id="element-108"></div>

      <div className="max-w-3xl mx-auto px-6 md:px-12 relative z-10" data-id="element-109">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-serif text-5xl md:text-6xl font-bold mb-6" data-id="element-110">
          The Future of Ownership Starts Here.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl text-gray-300 font-light mb-12" data-id="element-111">
          Be part of the movement redefining succession in Canada. Get notified
          when the report launches.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-112">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToNotify} className="bg-white text-brand-black px-10 py-5 rounded-full font-bold text-xl shadow-[0_0_40px_rgba(255,255,255,0.2)] hover:shadow-[0_0_60px_rgba(255,255,255,0.4)] transition-all duration-300" data-id="element-113">
            Join the Waitlist
          </motion.button>
        </motion.div>
      </div>
    </section>;
}